import { render, staticRenderFns } from "./retention-money.vue?vue&type=template&id=d5302f42&"
import script from "./retention-money.vue?vue&type=script&lang=js&"
export * from "./retention-money.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports